import { useEffect, useRef } from 'react';
import type { VoiceCallControls } from './useVoiceCall';

/**
 * During a live call, tell the voice each time the user starts sharing their
 * screen or adds a file: it cannot see either, and should delegate questions
 * about them to the assistant that can.
 */
export function useNoteSharedOnCall(
  { status, noteShared }: Pick<VoiceCallControls, 'status' | 'noteShared'>,
  shared: { screen: boolean; files: number },
): void {
  const live = status === 'live';

  useEffect(() => {
    if (live && shared.screen) noteShared('screen');
  }, [live, shared.screen, noteShared]);

  const filesSeen = useRef(shared.files);
  useEffect(() => {
    if (live && shared.files > filesSeen.current) noteShared('file');
    filesSeen.current = shared.files;
  }, [live, shared.files, noteShared]);
}
